import { render, staticRenderFns } from "./CaseUpdateEditor.vue?vue&type=template&id=4870729d&"
import script from "./CaseUpdateEditor.vue?vue&type=script&lang=js&"
export * from "./CaseUpdateEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports